import { useAppStore } from "@/store/app";
import { useEffectiveUser } from "./useEffectiveUser";
import { useEffect } from "react";

export function useInitializeDaysRangeFromUser() {
  const { user } = useEffectiveUser();
  const range = useAppStore((s) => s.selectedDaysRange);
  const setRange = useAppStore((s) => s.setSelectedDaysRange);

  useEffect(() => {
    if (!range && user?.preferred_days_range) {
      setRange(user.preferred_days_range);
    }
  }, [range, user?.preferred_days_range, setRange]);
}
